
// This component must be INSIDE the <Router> tags


import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
const HashScrollHandler = () => {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // Small delay to ensure the Home page components have finished rendering
      setTimeout(() => {
        const element = document.getElementById(hash.replace('#', ''));
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100); 
    }
  }, [hash]);

  return null; // This component doesn't render anything
};

export default HashScrollHandler;